import {
  Heading,
  Stack,
  Text,
  Flex,
  VStack,
  Center,
  Icon
} from '@chakra-ui/react';
import {
  PuzzlePieceIcon,
  SmileyIcon,
  FingerPrintIcon
} from '@components/common/icons';
import { SVGProps } from 'react';

interface IconSectionProps {
  title: string;
  text: string;
  icon: (props: SVGProps<SVGSVGElement>) => JSX.Element;
}

export const IconSection = ({
  icon,
  title,
  text
}: IconSectionProps): JSX.Element => {
  return (
    <VStack>
      <Center
        bg="primary.500"
        color="white"
        h="44px"
        w="44px"
        rounded="md"
        mb="18px"
        mt="24px"
      >
        <Icon h="24px" w="24px" as={icon} />
      </Center>
      <Heading fontSize={'24px'}>{title}</Heading>
      <Text maxW="270px">{text}</Text>
    </VStack>
  );
};

export const Hero = (): JSX.Element => {
  return (
    <Stack
      align="center"
      justifyContent={'center'}
      textAlign="center"
      spacing={4}
      h="100vh"
    >
      <Heading as="h2" size="md" color="primary.500">
        Our Mission
      </Heading>
      <Heading as="h1" size="h1">
        It all starts with the{' '}
        <Text
          as="span"
          bgGradient="linear-gradient(271.19deg, #17CCFC -28.89%, #6C47FF 80.53%)"
          bgClip="text"
        >
          user.
        </Text>
      </Heading>
      <Stack>
        <Text fontSize="xl" maxW="600px">
          We solve user management so developers can{' '}
          <b>stop re-inventing the wheel</b> and focus on their core business.
        </Text>
      </Stack>
      <Flex flexDir={{ base: 'column', md: 'row' }} gap={{ base: 6, md: 12 }}>
        <IconSection
          icon={SmileyIcon}
          title={'Easy'}
          text={`Use Clerk's fully featured UIs and dead simple APIs to add authentication in minutes instead of months.`}
        />
        <IconSection
          icon={PuzzlePieceIcon}
          title={'Integrative'}
          text={
            'At Clerk, we believe a component is worth 1,000 APIs and that they should work seamlessly in any stack so that you can build faster.'
          }
        />
        <IconSection
          icon={FingerPrintIcon}
          title={'Secure'}
          text={
            'Clerk is SOC 2 type certified, GDPR & CCPA compliant, and conducts regular third-party audits and pen testing.'
          }
        />
      </Flex>
    </Stack>
  );
};
